import React from "react";
import {
  CssBaseline,
  Box,
  Typography,
  Button,
  IconButton,
  Paper,
} from "@mui/material";
import imagebackground from "../../images/hrseg.png"; // Replace with your background image
import { useNavigate } from "react-router-dom";
import seg from "../../images/logosegnew.svg";
import image from "../../images/seosamie.png";
const PublicHome = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/login");
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100vh", // Ensure the entire page is 100vh
        backgroundImage: `url(${imagebackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CssBaseline />
      <img
        style={{
          width: "200px",
          position: "absolute", // This enables the top and left properties to position the element
          left: "52%", // Positions the left edge of the image at the center of the container
          top: "100px", // Positions the top edge of the image 100px down from the top of the container
          transform: "translateX(-50%)", // This shifts the image back to the left by half its width
        }}
        src={seg}
        alt="logo"
      />
      <h3
        style={{
          color: "#FBFAE8",
          fontSize: "15px",
          position: "absolute",
          left: "42%",
          top: "190px",
          lineHeight: "27px",
          fontFamily: "'Courier New', monospace", // Use a monospace font for consistent character width
          width: "600px", // Adjust width to maintain text alignment; adjust as necessary
          textAlign: "justify", // Justifies the text for uniform alignment
          hyphens: "auto", // Automatically hyphenates at appropriate points within words
        }}
      >
        SEG is a leading investment company <br />{" "}
        <span style={{ wordSpacing: "8px" }}>
          that owns,invests and manages a
        </span>{" "}
        <br />{" "}
        <span style={{ wordSpacing: "12px" }}>
          {" "}
          diverse portfolio of successful{" "}
        </span>{" "}
        <br /> companies in various sectors such <br /> as real
        estate,furniture,e-commerce,
        <br />
        trading,and mergers and acquisitions.
        <br />
        The company is distinguished by its <br />
        ability to drive innovation and <br /> achieve sustainable growth and
        value, <br /> making it a role model in the market,
        <br />
        which enhances its overall success.
      </h3>
      <img
        src={image}
        alt="image"
        style={{
          position: "absolute",
          width: "200px",
          left: "46%",
          top: "540px",
        }}
      />

      {/* Add Button */}
      <Button
        style={{
          position: "absolute",
          fontFamily: "cairo",
          backgroundColor: "Highlight",
          fontSize: "25px",
          right: "20px", // Adjust as needed
          top: "20px", // Adjust as needed
          color: "white", // Adjust color as needed
          borderColor: "white", // If using an outlined button
        }}
        onClick={handleClick}
      >
        دخـــول
      </Button>
    </div>
  );
};

export default PublicHome;
